import React, { useEffect, useRef } from "react";
import loadable from "@loadable/component";

// Core component that uses lottie-web. This code should only run in the browser.
const AnimationBase = ({ speed, animationData, mixBlendMode }) => {
  const container = useRef(null);

  useEffect(() => {
    // Only run in browser environment
    if (typeof window === 'undefined') return;

    // Dynamic import of lottie-web to prevent SSR issues
    import('lottie-web').then((lottie) => {
      if (!container.current) return;

      const anim = lottie.default.loadAnimation({
        container: container.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: animationData,
        mixBlendMode: mixBlendMode,
      });

      anim.setSpeed(speed); // Set the animation speed

      // Return cleanup function
      return () => anim.destroy();
    }).catch((error) => {
      console.error('Failed to load lottie animation:', error);
    });

  }, [speed, animationData, mixBlendMode]);

  return (
    <div
      ref={container}
      style={{
        position: "absolute",
        bottom: "0",
        left: "0",
        zIndex: "0",
        mixBlendMode: mixBlendMode,
        opacity: ".1",
      }}
    ></div>
  );
};

// Wrap the component with loadable to disable SSR for this component
const Animation = loadable(() => Promise.resolve(AnimationBase), {
  ssr: false,
});

export default Animation;